import React, { useState } from 'react';

import {
  DropdownMenu,
  DropdownOptions,
  DropdownHeader,
  DropdownHeadline,
  Department,
  DropdownButton,
  StyledAnchor
} from './styles';

import arrowIcon from '@/images/arrow-down.svg';

interface Props {
  filter: string;
  defaultSelection: string;
  dropdownText: string | null;
  handleSelection: (val: string | null, filter: string) => void;
  dropdownOptions: string[];
}

export function Dropdown({
  filter,
  dropdownText,
  dropdownOptions,
  defaultSelection,
  handleSelection
}: Props) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const onDropdownSelect = (selection: string | null) => {
    handleSelection(selection, filter);
    selection && setIsMenuOpen(!isMenuOpen);
  };

  const chooseDepartment = () => {
    handleSelection(null, filter);
    setIsMenuOpen(false);
  };

  return (
    <DropdownMenu
      onClick={() => setIsMenuOpen(!isMenuOpen)}
      align={filter === 'location' ? 'right' : 'left'}
      data-testid="dropdown"
    >
      <DropdownHeader>
        <DropdownHeadline>{dropdownText || defaultSelection}</DropdownHeadline>

        <DropdownButton
          src={arrowIcon}
          alt="dropdown arrow icon"
          isOpen={isMenuOpen}
        />
      </DropdownHeader>
      <DropdownOptions style={{ display: isMenuOpen ? 'flex' : 'none' }}>
        <Department onClick={chooseDepartment}>
          <StyledAnchor
            onClick={() => onDropdownSelect(null)}
            data-testid="all-anchor"
          >
            {defaultSelection}
          </StyledAnchor>
        </Department>
        {dropdownOptions.sort().map((selection: string) => (
          <Department key={selection}>
            <StyledAnchor
              onClick={() => onDropdownSelect(selection)}
              data-testid={selection}
            >
              {selection}
            </StyledAnchor>
          </Department>
        ))}
      </DropdownOptions>
    </DropdownMenu>
  );
}
